import { render } from "./신경외과.vue?vue&type=template&id=8d7887b4"
import script from "./신경외과.vue?vue&type=script&lang=js"
export * from "./신경외과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__